module.exports = __webpack_public_path__ + "web/img/wmv.8d929590.png";